import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=f4bdd630"
import script from "./CustomerSummary.vue?vue&type=script&lang=js"
export * from "./CustomerSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4bdd630')) {
      api.createRecord('f4bdd630', component.options)
    } else {
      api.reload('f4bdd630', component.options)
    }
    module.hot.accept("./CustomerSummary.vue?vue&type=template&id=f4bdd630", function () {
      api.rerender('f4bdd630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PanelGroup/CustomerSummary.vue"
export default component.exports